/* tslint:disable */
/* eslint-disable */
/**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { EventPostRequestEventData } from './EventPostRequestEventData';
import {
    EventPostRequestEventDataFromJSON,
    EventPostRequestEventDataFromJSONTyped,
    EventPostRequestEventDataToJSON,
} from './EventPostRequestEventData';

/**
 * 
 * @export
 * @interface EventPostRequest
 */
export interface EventPostRequest {
    /**
     * 
     * @type {string}
     * @memberof EventPostRequest
     */
    organization_id: string;
    /**
     * 
     * @type {string}
     * @memberof EventPostRequest
     */
    analytics_correlation_id: string;
    /**
     * 
     * @type {string}
     * @memberof EventPostRequest
     */
    window_location: string;
    /**
     * 
     * @type {string}
     * @memberof EventPostRequest
     */
    user_agent: string;
    /**
     * 
     * @type {EventPostRequestEventData}
     * @memberof EventPostRequest
     */
    event_data: EventPostRequestEventData;
}

/**
 * Check if a given object implements the EventPostRequest interface.
 */
export function instanceOfEventPostRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "organization_id" in value;
    isInstance = isInstance && "analytics_correlation_id" in value;
    isInstance = isInstance && "window_location" in value;
    isInstance = isInstance && "user_agent" in value;
    isInstance = isInstance && "event_data" in value;

    return isInstance;
}

export function EventPostRequestFromJSON(json: any): EventPostRequest {
    return EventPostRequestFromJSONTyped(json, false);
}

export function EventPostRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): EventPostRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'organization_id': json['organization_id'],
        'analytics_correlation_id': json['analytics_correlation_id'],
        'window_location': json['window_location'],
        'user_agent': json['user_agent'],
        'event_data': EventPostRequestEventDataFromJSON(json['event_data']),
    };
}

export function EventPostRequestToJSON(value?: EventPostRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'organization_id': value.organization_id,
        'analytics_correlation_id': value.analytics_correlation_id,
        'window_location': value.window_location,
        'user_agent': value.user_agent,
        'event_data': EventPostRequestEventDataToJSON(value.event_data),
    };
}

